import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { EsgPencilIcon } from 'assets';
import { COLORS } from 'components';
import { ScorecardDataItem } from 'api/scorecard';
import { AddNewRowModal } from '../../../../../modals';

interface EditRowButtonProps {
    rowData: ScorecardDataItem;
    onSave?: (rowId: number, data: any) => void;
    disabled?: boolean;
}

export const EditRowButton: React.FC<EditRowButtonProps> = ({ rowData, onSave, disabled = false }) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleOpenEditModal = () => {
        setIsEditModalOpen(true);
    };

    const handleCloseEditModal = () => {
        setIsEditModalOpen(false);
    };

    const handleSaveEdit = () => {
        // The modal will handle the API call, we just need to close it
        handleCloseEditModal();
    };

    return (
        <>
            <Tooltip
                arrow
                placement="top"
                title="Edit row">
                <IconButton
                    size="small"
                    onClick={handleOpenEditModal}
                    disabled={disabled}
                    sx={{
                        opacity: disabled ? 0.5 : 1,
                        cursor: disabled ? 'not-allowed' : 'pointer'
                    }}
                >
                    <EsgPencilIcon
                        color={COLORS.Romance}
                        style={{
                            width: '16px',
                            height: '16px'
                        }}
                    />
                </IconButton>
            </Tooltip>
            {isEditModalOpen && (
                <AddNewRowModal
                    isOpen={isEditModalOpen}
                    onClose={handleCloseEditModal}
                    rowData={rowData}
                    isEditMode
                    onSave={onSave || handleSaveEdit}
                />
            )}
        </>
    );
};
